import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import Overlay from 'react-bootstrap/Overlay';
import KizenTypography from 'app/kizentypo';
import TextInput from 'components/Inputs/TextInput';
import { ErrorCard } from '../../styles';

const SurveyNameInput = ({ value, errorMessage, ...rest }) => {
  const ref = useRef();
  const { t } = useTranslation();
  const showError = errorMessage.length > 0;

  return (
    <>
      <TextInput
        ref={ref}
        value={value}
        label={t('Name')}
        placeholder={t('Enter Name')}
        error={value?.length === 0}
        {...rest}
      />
      <Overlay
        transition={!showError}
        target={ref.current}
        show={showError}
        placement="bottom-start"
      >
        <ErrorCard show={showError}>
          <KizenTypography>{errorMessage}</KizenTypography>
        </ErrorCard>
      </Overlay>
    </>
  );
};

export default SurveyNameInput;
